import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'lib-pegase-accueil-header',
  standalone: true,
  imports: [],
  templateUrl: './pegase-accueil-header.component.html',
  styleUrls: ['./pegase-accueil-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PegaseAccueilHeaderComponent {
}
